module.exports = __webpack_public_path__ + "img/BlueBerry.9735b5a4.svg";